import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { HostCard } from '../components/HostCard';
import { ServiceFeature } from '../components/ServiceFeature';
import { motion } from 'framer-motion';
import { Sparkles, Crown, Calendar, Users, Zap, Shield, Gift, Star, ArrowRight } from 'lucide-react';
import { Button } from '../components/ui/Button';
export function VipHosts() {
  const hosts = [{
    name: 'Marcus Chen',
    title: 'Senior VIP Concierge',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=800&q=80',
    specialties: ['Bottle Service', 'Private Events', 'Celebrity Bookings'],
    bio: 'With 8+ years in luxury hospitality, Marcus specializes in creating unforgettable VIP experiences. Known for securing impossible reservations and curating perfect nights.',
    rating: 4.9,
    bookings: 500,
    instagram: 'https://instagram.com',
    phone: '+13015550101'
  }, {
    name: 'Sophia Rodriguez',
    title: 'VIP Experience Manager',
    image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=800&q=80',
    specialties: ['Bachelor/Bachelorette', 'Group Celebrations', 'Birthdays'],
    bio: 'Sophia brings energy and creativity to every event. Her attention to detail and personal touch make celebrations truly special. Perfect for milestone moments.',
    rating: 5.0,
    bookings: 350,
    instagram: 'https://instagram.com',
    phone: '+13015550102'
  }, {
    name: 'James Wellington',
    title: 'Elite Concierge',
    image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=800&q=80',
    specialties: ['Corporate Events', 'High-Profile Clients', 'Last-Minute Bookings'],
    bio: 'James excels under pressure and delivers excellence for high-profile clients. His network and expertise ensure seamless experiences for corporate and celebrity guests.',
    rating: 4.8,
    bookings: 450,
    instagram: 'https://instagram.com',
    phone: '+13015550103'
  }, {
    name: 'Aisha Patel',
    title: 'VIP Lifestyle Curator',
    image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=800&q=80',
    specialties: ['Bespoke Experiences', 'Luxury Packages', 'International Guests'],
    bio: 'Aisha crafts personalized luxury experiences that exceed expectations. Fluent in 4 languages, she specializes in welcoming international VIP guests with cultural sensitivity.',
    rating: 4.9,
    bookings: 300,
    instagram: 'https://instagram.com',
    phone: '+13015550104'
  }];
  const services = [{
    icon: Calendar,
    title: 'Priority Reservations',
    description: 'Skip the line and secure the best tables, even on sold-out nights. Your host handles all booking logistics.'
  }, {
    icon: Crown,
    title: 'Personalized Service',
    description: 'From bottle selection to special requests, your dedicated host ensures every detail matches your preferences.'
  }, {
    icon: Users,
    title: 'Group Coordination',
    description: 'Managing a large party? Your host coordinates guest lists, seating arrangements, and group dynamics seamlessly.'
  }, {
    icon: Gift,
    title: 'Special Occasions',
    description: 'Birthdays, proposals, celebrations - your host adds special touches to make moments unforgettable.'
  }, {
    icon: Shield,
    title: 'Discreet & Professional',
    description: 'Privacy and professionalism guaranteed. Your host manages everything with the utmost discretion.'
  }, {
    icon: Zap,
    title: '24/7 Availability',
    description: 'Last-minute plans? Your VIP host is available around the clock to accommodate your schedule.'
  }];
  const steps = [{
    number: '01',
    title: 'Choose Your Host',
    description: 'Browse our team and select the host that matches your needs and style.'
  }, {
    number: '02',
    title: 'Share Your Vision',
    description: 'Tell your host about your plans, preferences, and any special requests.'
  }, {
    number: '03',
    title: 'Relax & Enjoy',
    description: 'Your host handles everything - you just show up and experience the night.'
  }];
  return <div className="min-h-screen bg-[#0B1014] text-white flex flex-col" data-id="element-1073">
      <Header data-id="element-1074" />

      {/* Hero Section */}
      <div className="relative pt-32 pb-20 overflow-hidden" data-id="element-1075">
        <div className="absolute inset-0 bg-gradient-to-b from-[#DDA247]/10 via-transparent to-transparent" data-id="element-1076" />
        <div className="absolute top-20 left-1/3 w-96 h-96 bg-[#DDA247]/10 rounded-full blur-[120px]" data-id="element-1077" />
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-[#DDA247]/5 rounded-full blur-[120px]" data-id="element-1078" />

        <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-1079">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="max-w-4xl mx-auto text-center" data-id="element-1080">
            <div className="flex items-center justify-center gap-3 mb-6" data-id="element-1081">
              <Crown className="w-8 h-8 text-[#DDA247]" data-id="element-1082" />
              <span className="text-sm text-[#DDA247] uppercase tracking-[0.3em] font-medium" data-id="element-1083">
                Elite Concierge Service
              </span>
              <Crown className="w-8 h-8 text-[#DDA247]" data-id="element-1084" />
            </div>
            <h1 className="text-5xl md:text-7xl font-bold text-white uppercase tracking-tight mb-6 leading-tight" data-id="element-1085">
              VIP Hosts
            </h1>
            <p className="text-gray-400 text-lg md:text-xl leading-relaxed max-w-3xl mx-auto mb-8" data-id="element-1086">
              Your personal nightlife concierge. From securing impossible
              reservations to curating perfect experiences, our VIP hosts ensure
              every night is extraordinary.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-1087">
              <Button size="lg" className="group" data-id="element-1088">
                Meet Our Hosts
                <ArrowRight className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-1089" />
              </Button>
              <Button variant="outline" size="lg" data-id="element-1090">
                Learn More
              </Button>
            </div>
          </motion.div>
        </div>
      </div>

      {/* What We Do Section */}
      <section className="py-20 px-4 md:px-6 container mx-auto" data-id="element-1091">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-1092">
          <div className="flex items-center justify-center gap-2 mb-4" data-id="element-1093">
            <Sparkles className="w-5 h-5 text-[#DDA247]" data-id="element-1094" />
            <span className="text-xs text-[#DDA247] uppercase tracking-[0.3em] font-medium" data-id="element-1095">
              Premium Services
            </span>
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-white uppercase tracking-tight mb-4" data-id="element-1096">
            What VIP Hosts Do
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto" data-id="element-1097">
            More than just reservations - your host is your personal guide to an
            unforgettable night
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-1098">
          {services.map((service, index) => <ServiceFeature key={service.title} {...service} index={index} data-id="element-1099" />)}
        </div>
      </section>

      {/* Meet Our Hosts Section */}
      <section className="py-20 px-4 md:px-6 container mx-auto" data-id="element-1100">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-1101">
          <div className="flex items-center justify-center gap-2 mb-4" data-id="element-1102">
            <Star className="w-5 h-5 text-[#DDA247]" data-id="element-1103" />
            <span className="text-xs text-[#DDA247] uppercase tracking-[0.3em] font-medium" data-id="element-1104">
              Our Team
            </span>
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-white uppercase tracking-tight mb-4" data-id="element-1105">
            Meet Your Hosts
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto" data-id="element-1106">
            Each host brings unique expertise and personality to create your
            perfect experience
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-1107">
          {hosts.map((host, index) => <HostCard key={host.name} {...host} index={index} data-id="element-1108" />)}
        </div>
      </section>

      {/* How It Works Section */}
      <section className="py-20 px-4 md:px-6 container mx-auto" data-id="element-1109">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-1110">
          <h2 className="text-3xl md:text-5xl font-bold text-white uppercase tracking-tight mb-4" data-id="element-1111">
            How It Works
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto" data-id="element-1112">
            Three simple steps to an extraordinary night
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto" data-id="element-1113">
          {steps.map((step, index) => <motion.div key={step.number} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2,
          duration: 0.5
        }} className="relative text-center" data-id="element-1114">
              <div className="mb-6" data-id="element-1115">
                <div className="w-20 h-20 bg-gradient-to-br from-[#DDA247] to-[#DDA247]/50 rounded-full flex items-center justify-center mx-auto mb-4 shadow-[0_0_30px_rgba(221,162,71,0.3)]" data-id="element-1116">
                  <span className="text-3xl font-bold text-[#0B1014]" data-id="element-1117">
                    {step.number}
                  </span>
                </div>
                {index < steps.length - 1 && <div className="hidden md:block absolute top-10 left-[60%] w-[80%] h-0.5 bg-gradient-to-r from-[#DDA247]/50 to-transparent" data-id="element-1118" />}
              </div>
              <h3 className="text-xl font-bold text-white mb-3 uppercase tracking-wide" data-id="element-1119">
                {step.title}
              </h3>
              <p className="text-gray-400 text-sm leading-relaxed" data-id="element-1120">
                {step.description}
              </p>
            </motion.div>)}
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 px-4 md:px-6 container mx-auto" data-id="element-1121">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="relative bg-gradient-to-br from-[#DDA247]/20 via-[#DDA247]/10 to-transparent border border-[#DDA247]/30 rounded-3xl p-12 md:p-16 text-center overflow-hidden" data-id="element-1122">
          <div className="absolute top-0 right-0 w-64 h-64 bg-[#DDA247]/20 rounded-full blur-[100px]" data-id="element-1123" />
          <div className="relative z-10" data-id="element-1124">
            <Crown className="w-16 h-16 text-[#DDA247] mx-auto mb-6" data-id="element-1125" />
            <h2 className="text-3xl md:text-5xl font-bold text-white uppercase tracking-tight mb-6" data-id="element-1126">
              Ready for the VIP Treatment?
            </h2>
            <p className="text-gray-400 text-lg max-w-2xl mx-auto mb-8" data-id="element-1127">
              Connect with a VIP host today and experience House of Flavors like
              never before. Your unforgettable night starts here.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-1128">
              <Button size="lg" className="group" data-id="element-1129">
                Contact a Host
                <ArrowRight className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-1130" />
              </Button>
              <Button variant="outline" size="lg" data-id="element-1131">
                Call (301) 555-0100
              </Button>
            </div>
          </div>
        </motion.div>
      </section>

      <Footer data-id="element-1132" />
    </div>;
}